import { useEffect, useState } from "react";
import { Loader2, Send, Share2 } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { toast } from "sonner";
import { api, errMessage } from "../../lib/api";

// One-click educator share: emails a read-only progress summary to a
// teacher/therapist via Resend (managed email).
export const TeacherShare = () => {
  const [kids, setKids] = useState([]);
  const [childId, setChildId] = useState("");
  const [email, setEmail] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/children").then(({ data }) => {
      setKids(data);
      if (data.length) setChildId(data[0].child_id);
    }).catch(() => {});
  }, []);

  const send = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/children/share-report",
        { child_id: childId, email, note });
      if (data.emailed) {
        toast.success("Progress summary sent to the educator");
        setEmail(""); setNote("");
      } else {
        toast.error(`Email couldn't be sent: ${data.email_error || "try again"}`);
      }
    } catch (err) { toast.error(errMessage(err)); }
    setBusy(false);
  };

  if (!kids.length) return null;
  return (
    <div className="bg-card rounded-2xl border border-border p-5 space-y-3"
      data-testid="teacher-share-panel">
      <h3 className="text-sm font-bold font-display flex items-center gap-2">
        <Share2 className="h-4 w-4 text-secondary" aria-hidden="true" />
        Share progress with a teacher or therapist
      </h3>
      <p className="text-xs text-muted-foreground">
        Sends a read-only effort summary by email — speech practice, math levels
        and badges. No account needed on their side.
      </p>
      <form onSubmit={send} className="flex flex-wrap items-center gap-2">
        <select value={childId} onChange={(e) => setChildId(e.target.value)}
          className="rounded-full border border-border bg-background px-3 py-2 text-sm font-bold"
          data-testid="teacher-share-child" aria-label="Choose child">
          {kids.map((k) => <option key={k.child_id} value={k.child_id}>{k.display_name}</option>)}
        </select>
        <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="teacher@school.org" className="flex-1 min-w-44 rounded-full h-10"
          data-testid="teacher-share-email" />
        <Input value={note} onChange={(e) => setNote(e.target.value)} maxLength={300}
          placeholder="Optional note" className="flex-1 min-w-40 rounded-full h-10"
          data-testid="teacher-share-note" />
        <Button type="submit" size="sm" className="rounded-full gap-1 h-10"
          disabled={busy || !email} data-testid="teacher-share-send">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" /> : <Send className="h-4 w-4" aria-hidden="true" />}
          Send summary
        </Button>
      </form>
    </div>
  );
};
